@use '../../scss/global' as *;
@use 'themes';


@mixin full-screen-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.42);
  overflow-y: auto;
}

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-tour {

    fluid-modal {
      position: relative;
    }
  
    .overlay {
      @include full-screen-overlay();
  
      @include screen-ie-only() {
        justify-content: flex-start;
      }
  
      &.visible {
        @include fade-in(medium);
      }
  
      &.hidden {
        @include fade-out(short);
        overflow: hidden;
      }
    }

  }
}

